import { getModuleAccessCheckLib } from '../../utils/accessControlUtils';

const moduleAccessCheckLib = getModuleAccessCheckLib();

export const PlatformTabs = {
  People: {
    id: 'peopleSettings',
    label: 'People',
    data: [
      {
        enabled: true,
        label: 'Members',
        id: 'members'
      },
      {
        enabled: true,
        label: 'Permissions',
        id: 'permissions'
      },
      {
        enabled: true,
        label: 'Org hierarchy',
        id: 'org-hierarchy',
        product: 'apps'
      },
      {
        enabled: true,
        label: 'Errors',
        id: 'errors',
        product: 'apps'
      }
    ]
  },
  Module_Access: {
    id: 'module_access',
    label: 'Module Access',
    data: [
      {
        enabled: true,
        label: 'Module Access',
        id: 'module-access',
        product: 'apps'
      }
    ]
  },
  Integrations: {
    id: 'integrations',
    label: 'Integrations',
    data: [
      {
        enabled: true,
        label: 'Integrations',
        id: 'integrations'
      }
    ]
  },
  Data_Sharing: {
    id: 'data_sharing',
    label: 'Data Sharing',
    data: [
      {
        enabled: true,
        label: 'Data Sharing',
        id: 'data-sharing'
      }
    ]
  }
};

export const ModuleTabs = {
  Objectives: {
    id: 'objectivesModuleSettings',
    label: 'Objectives',
    module: 'okr',
    visibilityFunction: moduleAccessCheckLib.hasOkrModuleAccess,
    data: [
      {
        enabled: true,
        label: 'Notifications',
        id: 'notifications'
      },
      {
        enabled: false,
        label: 'Execution cycles',
        id: 'execution-cycles'
      },
      {
        enabled: true,
        label: 'Visibility controls',
        id: 'visibility-controls'
      },
      {
        enabled: true,
        label: 'Customization',
        id: 'objective-customization'
      },
      {
        enabled: false,
        label: 'Bulk upload',
        id: 'bulk-upload'
      },
      {
        enabled: true,
        label: 'Permissions',
        id: 'objective-permissions'
      }
    ]
  },
  Feedback: {
    id: 'feedbackModuleSettings',
    label: 'Feedback',
    module: 'feedback',
    visibilityFunction: moduleAccessCheckLib.hasFeedbackModuleAccess,
    data: [
      {
        enabled: true,
        label: 'Customization',
        id: 'feedback-customization',
        type: 'feedback'
      },
      {
        enabled: true,
        label: 'Values',
        id: 'values',
        type: 'feedback'
      },
      {
        enabled: false,
        label: 'Competencies',
        id: 'competencies',
        type: 'feedback'
      }
    ]
  },
  Surveys: {
    id: 'surveysModuleSettings',
    label: 'Surveys',
    module: 'surveys',
    // modify this visibility function to change the access for surveys
    // currently it will be SUPER_HR or SUPER_ADMIN in surveys module
    visibilityFunction:
      moduleAccessCheckLib.hasSurveyModuleAccessAndIsSuperHrOrAbove,
    data: [
      {
        enabled: true,
        label: 'Surveys',
        id: 'surveys-customization',
        type: 'surveys'
      }
    ]
  }
};
